import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import Breadcrumb from "../../commons/breadcrumb/breadcrumb";
import Button from "../../commons/button/button";
import Input from "../../commons/input/input";
import "./invoice.css";

const Invoice = () => {
  const getOrerNumber = () => {
    const localStorageProduct = JSON.parse(localStorage.getItem("cartItems"));
    return localStorageProduct.length;
  };

  const cartItems = useSelector((state) => state.cart);

  const generatePricec = () => {
    let price = cartItems.cartItems.reduce((acc, item) => acc + item.price, 0);
    let str_price = String(price);
    let count_char_price = str_price.length;

    console.log(price, "price");
    console.log(str_price, "str_price");
    console.log(count_char_price, "count_char_price");

    switch (count_char_price) {
      case 5:
        let first_sec = str_price.substring(0, 2);
        let secound_sec = str_price.substring(2);
        price = first_sec + "," + secound_sec;
        return price;
      case 4:
        first_sec = str_price.substring(0, 1);
        secound_sec = str_price.substring(1);
        price = first_sec + "," + secound_sec;
        return price;
      case 6:
        first_sec = str_price.substring(0, 3);
        secound_sec = str_price.substring(3);
        price = first_sec + "," + secound_sec;
        return price;
      case 7:
        first_sec = str_price.substring(0, 4);
        secound_sec = str_price.substring(4);
        price = first_sec + "," + secound_sec;
        return price;
      case 8:
        first_sec = str_price.substring(0, 8);
        secound_sec = str_price.substring(8);
        price = first_sec + "," + secound_sec;
        return price;
      default:
        break;
    }

    return price;
  };

  return (
    <Fragment>
      <div className="container-fluid invoice_page_body">
        <div className="container page_body">
          <Breadcrumb bread2="صورتحساب" />
          <div className="invoice_body">
            <div className="row invoice_row_body">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 invoice_small_sec ">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <h5 className="invoice_order_text">جزئیات سفارش شما</h5>
                  </div>
                </div>
                <div className="row order_number_body">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 number_of_order_value ">
                    <span className="order_number_value">{`${getOrerNumber()}`}</span>

                    <span> عدد </span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 number_of_order_title">
                    <div> : تعداد محصولات</div>
                  </div>
                </div>
                <div className="row order_price_body">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 price_of_order_value ">
                    <span className="order_price_value">
                      {generatePricec()}
                    </span>

                    <span> تومان </span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 number_of_order_title">
                    <div> : هزینه فاکتور</div>
                  </div>
                </div>
                <div className="row order_port_body">
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 port_of_order_value ">
                    <span> زرین پال </span>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 port_of_order_title">
                    <div> : درگاه پرداخت</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 order_btn_body">
                    <Button
                      boxShadow="0px 0px 13px -3px #636e72"
                      background="#a5c926"
                      color="white"
                      heigh="50px"
                      width="180px"
                      radius="23px"
                      tooltip={"با کلیک ، به صفحه پرداخت منتقل خواهید شد"}
                      tooltiploc="bottom"
                    >
                      تکمیل پرداخت
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 invoice_big_sec">
                <div className="invoice_detail">
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <h5 className="invoice_detail_text">جزئیات پرداخت</h5>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <div className="famiy_input_text">نام خانوادگی</div>
                      <div className="family_input_body">
                        <Input
                          width="100%"
                          placeHolder="فامیل"
                          className="family_input"
                          direction="rtl"
                        />
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                      <div className="name_input_text">نام </div>
                      <div className="name_input_body">
                        <Input
                          width="100%"
                          placeHolder="اسم "
                          className="name_input"
                          direction="rtl"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div className="mail_sec_title">آدرس ایمیل</div>
                      <div>
                        <Input
                          width="100%"
                          placeHolder="آدرس پست الکترونیکی"
                          className="email_input"
                          direction="rtl"
                          type="mail"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div className="phone_sec_title">شماره تلفن</div>
                      <div className="phone_input_body">
                        <Input
                          width="50%"
                          placeHolder="تلفن همراه یا ثابت"
                          className="phone_input"
                          direction="rtl"
                          type="number"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="create_account_sec">
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <h5 className="invoice_account_text">
                        ساخت اکانت کاربری
                      </h5>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div className="username_sec_title">یوزر نیم</div>
                      <div>
                        <Input
                          width="100%"
                          placeHolder="یوزر اکانت باید با حروف انگلیسی باشد"
                          className="usename_input"
                          direction="ltr"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                      <div className="password_sec_title">پسورد</div>
                      <div>
                        <Input
                          width="100%"
                          placeHolder="پسورد باید شامل 8 کاراکتر و رقم باشد"
                          className="password_input"
                          direction="ltr"
                          type="password"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Invoice;
